// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-pagination_PaginationWrapper__LEpm1 {
    gap: 6px;
    display: flex;
    direction: rtl;
    padding: 20px 0;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;
}

.page-pagination_PaginationBtn__2d7p9 {
    height: 38px;
    color: #333;
    min-width: 38px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    border-radius: 8px;
    font-family: inherit;
    border: 1px solid #ddd;
    background-color: #fff;
    transition: all 0.2s ease;
}

.page-pagination_PaginationBtn__2d7p9:hover:not(.page-pagination_Disabled__L7h5k):not(.page-pagination_Active__gHudS) {
    border-color: #bbb;
    background-color: #f0f0f0;
}

.page-pagination_Active__gHudS {
    color: #fff;
    cursor: default;
    font-weight: bold;
    border-color: rgb(255, 217, 178);
    background-color: rgb(178, 143, 107);
}

.page-pagination_Disabled__L7h5k {
    opacity: 0.4;
    cursor: not-allowed;
}

.page-pagination_Ellipsis__9i-Vl {
    height: 38px;
    display: flex;
    color: #999;
    min-width: 38px;
    font-size: 16px;
    -webkit-user-select: none;
            user-select: none;
    align-items: center;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/page-pagination/page-pagination.module.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;IACR,aAAa;IACb,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,WAAW;IACX,eAAe;IACf,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".PaginationWrapper {\r\n    gap: 6px;\r\n    display: flex;\r\n    direction: rtl;\r\n    padding: 20px 0;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: row-reverse;\r\n}\r\n\r\n.PaginationBtn {\r\n    height: 38px;\r\n    color: #333;\r\n    min-width: 38px;\r\n    font-size: 14px;\r\n    padding: 0 10px;\r\n    cursor: pointer;\r\n    border-radius: 8px;\r\n    font-family: inherit;\r\n    border: 1px solid #ddd;\r\n    background-color: #fff;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.PaginationBtn:hover:not(.Disabled):not(.Active) {\r\n    border-color: #bbb;\r\n    background-color: #f0f0f0;\r\n}\r\n\r\n.Active {\r\n    color: #fff;\r\n    cursor: default;\r\n    font-weight: bold;\r\n    border-color: rgb(255, 217, 178);\r\n    background-color: rgb(178, 143, 107);\r\n}\r\n\r\n.Disabled {\r\n    opacity: 0.4;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.Ellipsis {\r\n    height: 38px;\r\n    display: flex;\r\n    color: #999;\r\n    min-width: 38px;\r\n    font-size: 16px;\r\n    user-select: none;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PaginationWrapper": `page-pagination_PaginationWrapper__LEpm1`,
	"PaginationBtn": `page-pagination_PaginationBtn__2d7p9`,
	"Disabled": `page-pagination_Disabled__L7h5k`,
	"Active": `page-pagination_Active__gHudS`,
	"Ellipsis": `page-pagination_Ellipsis__9i-Vl`
};
export default ___CSS_LOADER_EXPORT___;
